import { request, qs } from './api';

// GET  /place-images        -> list (envelope {data,...} OR plain array — page handles both)
// DELETE /place-images/:id  -> remove one image (backend: /admin/place-images/<int:image_id>)
// POST /place-images/bulk-delete { image_ids:[...] } -> remove many
export const listPlaceImages = (params) => request(`/place-images${qs(params)}`);
// GET /place-images/all -> every place image (not just the moderation queue)
export const listAllPlaceImages = (params) => request(`/place-images/all${qs(params)}`);
export const deletePlaceImage = (id) => request(`/place-images/${id}`, { method: 'DELETE' });
export const bulkDeletePlaceImages = (imageIds) =>
  request('/place-images/bulk-delete', { method: 'POST', body: { image_ids: imageIds } });

// POST /place-images/moderate { image_ids:[...], moderated:true } -> mark images moderated
export const moderatePlaceImages = (imageIds, moderated = true) =>
  request('/place-images/moderate', { method: 'POST', body: { image_ids: imageIds, moderated } });
